import React from "react";

const EventTypesList = ({
  eventTypes,
  styles,
  screenSize,
  language,
  theme,
  onTypeClick,
}) => {
  return (
    <div style={styles.sidebarCard1}>
      {eventTypes.map((type) => (
        <div
          key={type.id}
          style={{
            display: "flex",
            alignItems: "center",
            gap: screenSize.isMobile ? "12px" : "26px",
            marginBottom: screenSize.isMobile ? "8px" : "42px",
            paddingBottom:
              type.id === "event"
                ? screenSize.isMobile
                  ? "20px"
                  : "32px"
                : 0,
            borderBottom:
              type.id === "event"
                ? theme === "dark"
                  ? "1px solid rgba(255,255,255,0.1)"
                  : "1px solid rgba(0,0,0,0.08)"
                : "none",
            flexDirection: language === "ar" ? "row-reverse" : "row",
            cursor: "pointer",
          }}
          onClick={() => onTypeClick(type)}
        >
          <div
            style={{
              width: screenSize.isMobile ? "32px" : "40px",
              height: screenSize.isMobile ? "32px" : "40px",
              borderRadius: screenSize.isMobile ? "10px" : "12px",
              background: `${type.color}20`,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              color: type.color,
              flexShrink: 0,
            }}
          >
            <type.icon size={screenSize.isMobile ? 16 : 20} />
          </div>
          <div style={{ flex: 1, textAlign: language === "ar" ? "right" : "left" }} />
        </div>
      ))}
    </div>
  );
};

export default EventTypesList;
